var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmlBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48 2H16a4 4 0 0 0-4 4v52a4 4 0 0 0 4 4h32a4 4 0 0 0 4-4V10z",
    fill: "#AF5EDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 10h-8a4 4 0 0 1-4-4V2z",
    fill: "#934AC2"
  }), /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 45,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "white"
  }, "XML"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlBig);
export default __webpack_public_path__ + "static/media/XMLBig.f9bcc8c9f82849de584fc5ad41691ace.svg";
export { ForwardRef as ReactComponent };